// Bootstrap do SSO administrativo emitido pelo Brutos Admin Central.
// O painel admin guarda sessao em localStorage (mesmo padrao do login local),
// entao a gravacao precisa acontecer NA ORIGEM do admin-frontend. Ao pousar em
// /api/admin-sso/consume?token=..., trocamos o token curto por um JWT platform-admin
// no backend e gravamos a sessao localmente, preservando o login/senha como fallback.

const STORAGE_KEY = 'brutos-platform-admin-session';
const CONSUME_PATH = '/api/admin-sso/consume';

const ADMIN_HOSTS = new Set([
  'admingestor.brutosdelivery.cloud',
  'admin.brutosdelivery.cloud',
]);

// Mesma resolucao de API usada em App.js (mantida em sincronia manualmente).
function resolveApiUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window === 'undefined') return '';
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:3001`;
  }
  if (ADMIN_HOSTS.has(hostname)) {
    return `${protocol}//backend.brutosdelivery.cloud`;
  }
  return '';
}

export function isAdminSsoLanding() {
  if (typeof window === 'undefined') return false;
  if (window.location.pathname !== CONSUME_PATH) return false;
  const params = new URLSearchParams(window.location.search);
  return Boolean(params.get('token'));
}

// Troca o token curto por um JWT platform-admin e grava a sessao local.
export async function consumeAdminSso() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  const apiUrl = resolveApiUrl();

  const response = await fetch(`${apiUrl}${CONSUME_PATH}?token=${encodeURIComponent(token)}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.token || !data?.user) {
    throw new Error(data?.error || 'Falha no SSO administrativo.');
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: data.token, user: data.user }));
  return data.redirectTo || '/';
}
